// eslint-disable-next-line eag/match-named-export -- Pre-existing violation
import {openConfirmDialog} from 'platform/components';

import i18n from '@dms/i18n';
import {useAdPlatformsVehicleUpdate} from '@dms/shared';

export function useConfirmRepublishAds() {
  const {hasPublishedAdvertisements} = useAdPlatformsVehicleUpdate();

  return function confirmRepublishAds(
    vehicleId: string,
    onRepublishAds: (republishAds: boolean) => void,
    onBeforeDialog?: () => void
  ) {
    return hasPublishedAdvertisements(vehicleId).then((hasAdvertisements) => {
      onBeforeDialog?.();

      if (!hasAdvertisements) {
        onRepublishAds(false);
        return;
      }

      let republishAds = false;

      openConfirmDialog({
        text: i18n.t('entity.vehicle.labels.infoChangedUpdateClassifiedsQuestion'),
        onConfirm: () => {
          republishAds = true;
        },
        onCloseComplete: () => onRepublishAds(republishAds),
      });
    });
  };
}
